import { languages_enum } from "redux/actions/globalSlice";
import { TDoctorsFiltersFormValue } from "../Doctors.types";

interface composeDoctorsQueryVariablesProps {
  currentPage?: number;
  language?: languages_enum;
  doctorsFiltersFormValue: TDoctorsFiltersFormValue;
  pageSize: number;
}

export const composeDoctorsQueryVariables = ({
  currentPage,
  language,
  doctorsFiltersFormValue,
  pageSize
}: composeDoctorsQueryVariablesProps) => {
  return `${language}?page=${currentPage || 1}&per_page=${
    pageSize || 12
  }&specialty=${doctorsFiltersFormValue.speciality?.value || ""}&name=${
    doctorsFiltersFormValue.name || ""
  }&branch=${doctorsFiltersFormValue.branch?.value || ""}&order=${
    doctorsFiltersFormValue.order?.value || ""
  }&order_by=${doctorsFiltersFormValue.order_by?.value || ""}`;
};
